import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=dbb8a696"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/89/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbb8a696')) {
      api.createRecord('dbb8a696', component.options)
    } else {
      api.reload('dbb8a696', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=dbb8a696", function () {
      api.rerender('dbb8a696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/MobileNavigation.vue"
export default component.exports